'use client';

import { Button } from '@/components/ui/button';
import { Copy, Share2, Check } from 'lucide-react';
import { useState } from 'react';
import { buildLinkedInShareUrl, buildXShareUrl, formatHashtags } from './shared/utils';

interface SocialPostActionsProps {
  platform: 'linkedin' | 'twitter' | 'instagram';
  caption: string;
  hashtags?: string[];
}

export function SocialPostActions({ platform, caption, hashtags }: SocialPostActionsProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const fullText = hashtags?.length ? `${caption}\n\n${formatHashtags(hashtags)}` : caption;
    await navigator.clipboard.writeText(fullText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShare = () => {
    let shareUrl: string;
    if (platform === 'linkedin') {
      shareUrl = buildLinkedInShareUrl(caption);
    } else if (platform === 'twitter') {
      shareUrl = buildXShareUrl(caption, hashtags);
    } else {
      handleCopy();
      return;
    }
    window.open(shareUrl, '_blank', 'width=600,height=500');
  };

  const platformLabels = {
    linkedin: 'LinkedIn',
    twitter: 'X',
    instagram: 'Instagram',
  };

  return (
    <div className="flex gap-2 mt-3 pt-3 border-t">
      <Button variant="outline" size="sm" onClick={handleCopy} className="flex-1">
        {copied ? <Check className="w-4 h-4 mr-2" /> : <Copy className="w-4 h-4 mr-2" />}
        {copied ? 'Copied!' : 'Copy Caption'}
      </Button>
      <Button variant="outline" size="sm" onClick={handleShare} className="flex-1">
        <Share2 className="w-4 h-4 mr-2" />
        {platform === 'instagram' ? 'Copy for Instagram' : `Open in ${platformLabels[platform]}`}
      </Button>
    </div>
  );
}
